const contactData = [
  {
    id: '1',
    name: "Nancy Martino",
    designation: "Team Leader & HR",
    image: "assets/images/users/avatar-2.jpg",
  },
  {
    id: '2',
    name: "Henry Baird",
    designation: "Full Stack Developer",
    image: "assets/images/users/avatar-1.jpg",
  },
  {
    id: '3',
    name: "Frank Hook",
    designation: "Project Manager",
    image: "assets/images/users/avatar-3.jpg",
  },
  {
    id: '4',
    name: "Jennifer Carter",
    designation: "UI/UX Designer",
    image: "assets/images/users/avatar-4.jpg",
  },
  {
    id: '5',
    name: "Hollis Spencer",
    designation: "React Developer",
    avatar: "HS",
  },
  {
    id: '6',
    name: "Megan Elmore",
    designation: "Team Leader & Web Developer",
    image: "assets/images/users/avatar-5.jpg",
  },
  {
    id: '7',
    name: "Alexis Clarke",
    designation: "Backend Developer",
    image: "assets/images/users/avatar-6.jpg",
  },
  {
    id: '8',
    name: "Nathan Cole",
    designation: "Front-End Developer",
    image: "assets/images/users/avatar-7.jpg",
  },
  {
    id: '9',
    name: "Joseph Parker",
    designation: "Full Stack Developer",
    image: "assets/images/users/avatar-8.jpg",
  },
  {
    id: '10',
    name: "Josefa Weissnat",
    designation: "Project Manager",
    image: "assets/images/users/avatar-10.jpg",
  },
  {
    id: '11',
    name: "Erica Kernan",
    designation: "Web Designer",
    image: "assets/images/users/avatar-9.jpg",
  },
  {
    id: '12',
    name: "Axel Kozey",
    designation: "React Developer",
    avatar: "AK",
  },
]

export { contactData }